import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE } from '../../../../../configs';
import { dateFormatter, infoFormatterIntl, localeFormatter } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function VehicleCertificateView(props) {
  const {
    fieldsValidation = {},
    procedure,
    currentApplication = {},
  } = props;

  const application_vehicle_new = currentApplication?.application_vehicle_new || {};
  const registry_subject = currentApplication?.registry_subject || {};
  const files = currentApplication?.files || [];

  const {
    vehicle_registration_number,
    vehicle_registration_issue_date,
    has_special_lifting_device,
    ownership_type,
  } = application_vehicle_new;

  const {
    vehicle_registration_number: old_vehicle_registration_number,
    ownership_type: old_ownership_type,
  } = registry_subject;

  const applicant_car_cd_file = files.filter(item => item.collection_name === 'applicant_car_cd_file');
  const car_photo_file = files.filter(item => item.collection_name === 'car_photo_file');
  const hasVehicleCertificateData = !!(
    vehicle_registration_number
            || vehicle_registration_issue_date
            || has_special_lifting_device
            || ownership_type
  ) || vehicle_registration_number === null
        || vehicle_registration_issue_date === null
        || has_special_lifting_device === null
        || ownership_type === null;

  if (![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure)) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasVehicleCertificateData,
            }}
            label="Изменились сведения о СТС"
          />
        </Col>
      </Row>
      {hasVehicleCertificateData && (
      <>
        <Row className="row-cols-3">
          {infoFormatterIntl(
            'old.vehicle_registration_number',
            old_vehicle_registration_number,
            fieldsValidation,
            'registry_subject.vehicle_registration_number',
          )}
          {infoFormatterIntl(
            'new.vehicle_registration_number',
            vehicle_registration_number,
            fieldsValidation,
            'application_vehicle_new.vehicle_registration_number',
          )}
        </Row>

        <Row className="row-cols-3">
          {infoFormatterIntl(
            'new.vehicle_registration_issue_date',
            dateFormatter(vehicle_registration_issue_date),
            fieldsValidation,
            'application_vehicle_new.vehicle_registration_issue_date',
          )}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl(
            'media.applicant_car_cd_file',
            applicant_car_cd_file.length ? (
              <FileView
                readOnly
                withoutMime
                withoutHr
                files={applicant_car_cd_file}
              />
            ) : null,
            fieldsValidation,
            '',
            4,
          )}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl(
            'new.has_special_lifting_device',
            has_special_lifting_device ? 'Да' : 'Нет',
            fieldsValidation,
            'application_vehicle_new.has_special_lifting_device',
          )}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl(
            'old.ownership_type',
            localeFormatter('ownership.type', old_ownership_type),
            fieldsValidation,
            'registry_subject.ownership_type',
          )}
          {infoFormatterIntl(
            'new.ownership_type',
            localeFormatter('ownership.type', ownership_type),
            fieldsValidation,
            'application_vehicle_new.ownership_type',
          )}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl(
            'media.car_photo_file',
            car_photo_file.length ? (
              <FileView
                readOnly
                withoutMime
                withoutHr
                files={car_photo_file}
              />
            ) : null,
            fieldsValidation,
            '',
            6,
          )}
        </Row>
      </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
